const TrendIcon = ({
    color="#027445"
}) => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3712_51814)">
                <path d="M10.5001 3H7.50013C7.22363 3 7.00013 3.2235 7.00013 3.5C7.00013 3.7765 7.22363 4 7.50013 4H10.2931L7.01213 7.281C6.73013 7.563 6.27113 7.563 5.98863 7.281L4.71913 6.0115C4.04713 5.3395 2.95363 5.3395 2.28163 6.0115L0.146625 8.1465C-0.048875 8.342 -0.048875 8.658 0.146625 8.8535C0.244125 8.951 0.372125 9 0.500125 9C0.628125 9 0.756125 8.951 0.853625 8.8535L2.98863 6.7185C3.26213 6.445 3.73863 6.445 4.01213 6.7185L5.28163 7.988C5.95363 8.66 7.04713 8.66 7.71913 7.988L11.0006 4.707V7.5C11.0006 7.7765 11.2241 8 11.5006 8C11.7771 8 12.0006 7.7765 12.0006 7.5V4.5C12.0006 3.673 11.3271 3 10.5001 3Z" fill={color} />
            </g>
            <defs>
                <clipPath id="clip0_3712_51814">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>

    );
};

export default TrendIcon;
